import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["playlistIds"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import { formatPlaylistAudienceAndTeams } from 'utils/playlist/formatPlaylistAudienceAndTeams';
import { formatPlaylistAutoShare } from 'utils/playlist/formatPlaylistAutoShare';
import isAdmin from 'utils/session/isAdmin';
import { playlistQueryKeys } from 'actions/playlists';
function formatShareData(obj) {
  formatPlaylistAudienceAndTeams(obj);
  delete obj.contentTeams;
  delete obj.assetDomains;
  formatPlaylistAutoShare(obj);
  return obj;
}
function useFetchPlaylistsShareData(_ref) {
  var playlistIds = _ref.playlistIds,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchPlaylistsShareData() {
    return _fetchPlaylistsShareData.apply(this, arguments);
  }
  function _fetchPlaylistsShareData() {
    _fetchPlaylistsShareData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resp;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return api('get', '/api/query/collectionAsset', {
              fields: ['id', {
                contentTeams: ['id', 'isCalculated', {
                  team: ['name', 'id', 'isSmartTeam', 'is_deleted', {
                    teamType: ['id', 'name', 'rank', 'colour', 'role']
                  }]
                }]
              }, {
                assetDomains: ['audience', 'audienceCalculated']
              }, {
                teamSharing: ['team_id', 'is_deleted', {
                  teams: ['name', 'id', 'isSmartTeam', {
                    teamType: ['id', 'name', 'rank', 'colour']
                  }]
                }]
              }],
              join: {
                contentTeams: {
                  isCalculated: [0, 1]
                }
              },
              filter: {
                id: playlistIds
              },
              limit: playlistIds.length,
              notfound: undefined
            });
          case 1:
            resp = _context.sent;
            return _context.abrupt("return", resp.items.map(formatShareData));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchPlaylistsShareData.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread({
      queryKey: playlistQueryKeys.playlistShareDataSelection(playlistIds),
      queryFn: fetchPlaylistsShareData,
      enabled: isAdmin()
    }, queryOptions)),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? [] : _useQuery$data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    items: data
  }, result);
}
export default useFetchPlaylistsShareData;